export const isZeroWidth = (width: string | undefined): boolean => width === '0px' || width === '0';

export const isNonContributingSidepanel = (tile: {
    readonly id: string;
    readonly kind?: string;
    readonly width?: string;
}): boolean => {
    if (tile.kind === 'dock' && (isZeroWidth(tile.width) || tile.width === undefined)) {
        return true;
    }

    return isZeroWidth(tile.width);
};

export const buildWidthCssTransition = (durationSeconds: number): string => {
    if (durationSeconds <= 0) {
        return 'none';
    }

    const duration = `${durationSeconds}s`;

    return `width ${duration} cubic-bezier(.215, .61, .355, 1), min-width ${duration} cubic-bezier(.215, .61, .355, 1), max-width ${duration} cubic-bezier(.215, .61, .355, 1)`;
};
